import { render, staticRenderFns } from "./scrollcenter.vue?vue&type=template&id=3e9a6580&"
import script from "./scrollcenter.vue?vue&type=script&lang=js&"
export * from "./scrollcenter.vue?vue&type=script&lang=js&"
import style0 from "./scrollcenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports